import { useMemo } from 'react';

import Box from '@zenbusiness/zui/Box';
import Chip from '@zenbusiness/zui/Chip';
import CircularProgress from '@zenbusiness/zui/CircularProgress';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { BoxStyled, IconWrapper } from './MoveMoneyOption.styles';

export default function MoveMoneyOption({
  icon,
  title,
  description,
  onClick,
  label,
  isDisable,
  isLoading
}) {
  const endIcon = useMemo(
    () =>
      isLoading ? (
        <CircularProgress
          color="inherit"
          size={16}
        />
      ) : (
        <SharedAsset
          alt=""
          height={20}
          src="/s2/icon/arrow-sm-right-fill.svg"
          width={20}
        />
      ),
    [isLoading]
  );

  return (
    <BoxStyled
      aria-label={title}
      isDisable={isDisable}
      onClick={isDisable ? null : onClick}
      role="listitem"
    >
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
      >
        <Stack
          alignItems="center"
          direction="row"
          gap="16px"
        >
          <Box>
            <IconWrapper
              alignItems="center"
              disabled={isDisable}
              justifyContent="center"
            >
              {icon}
            </IconWrapper>
          </Box>
          <Stack gap="4px">
            <Stack
              direction="row"
              gap="4px"
            >
              <Text
                color="primary"
                size="xl"
                weight="medium"
              >
                {title}
              </Text>
              {label && (
                <Chip
                  sx={(theme) => ({
                    backgroundColor: theme.palette.background.cyan.light
                  })}
                >
                  {label}
                </Chip>
              )}
            </Stack>
            <Text
              color="tertiary"
              size="md"
            >
              {description}
            </Text>
          </Stack>
        </Stack>
        <Stack
          alignItems="center"
          height={44}
          justifyContent="center"
          width={44}
        >
          {endIcon}
        </Stack>
      </Stack>
    </BoxStyled>
  );
}

MoveMoneyOption.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  isDisable: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool
};
